import { Pencil } from "lucide-react";
import FormCard from "@/app/components/atoms/FormCard";

interface ConfirmedEmailCardProps {
  email: string;
  onEdit: () => void;
}

/**
 * @component ConfirmedEmailCard
 * @description Read-only email display card with a pencil edit button.
 * Reused across registration steps (phone, password) to show the confirmed
 * email with an option to go back and change it.
 * @param email - The confirmed email address to display.
 * @param onEdit - Callback fired when the user clicks the edit button.
 * @returns A FormCard containing the email label, value, and edit control.
 */
export default function ConfirmedEmailCard({ email, onEdit }: ConfirmedEmailCardProps) {
  return (
    <FormCard>
      <div className="flex flex-col gap-1">
        <div className="flex items-center justify-between gap-2">
          <span className="text-label text-muted-text">Email</span>
          <button
            type="button"
            onClick={onEdit}
            aria-label="Edit email address"
            className="p-1 text-charcoal hover:text-accent-green transition-colors min-w-[44px] min-h-[44px] flex items-center justify-center"
          >
            <Pencil className="w-4 h-4" aria-hidden />
          </button>
        </div>
        <p className="text-body-base text-muted-text">{email}</p>
      </div>
    </FormCard>
  );
}
